const carouselItems = [
  {
    title: '2026暑期档 · 必看大片指南',
    desc: '从动作巨制到温馨动画，今夏最值得期待的十部院线新片全收录。科幻巨作《星际穿越2》领衔，国产悬疑《消失的真相》口碑爆棚。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20dramatic%20lighting%2C%20action%20and%20sci-fi%20film%20elements%2C%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20widescreen%20composition%2C%20epic%20scale%2C%20no%20text%2C%20high%20contrast%20film%20photography&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '暑期专题',
  },
  {
    title: 'IMDB Top 250 · 一生必看经典',
    desc: '影史经典一次看够！从《肖申克的救赎》到《寄生虫》，跨越时空的顶级佳作。每部都是影迷入门必修课，高分不踩雷。',
    img: 'https://readdy.ai/api/search-image?query=Classic%20film%20history%20montage%20with%20vintage%20cinema%20aesthetic%2C%20golden%20age%20Hollywood%20and%20modern%20masterpieces%20fusion%2C%20warm%20sepia%20and%20amber%20tones%2C%20film%20reels%20and%20awards%20atmosphere%2C%20no%20text%2C%20artistic%20composition&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '经典专题',
  },
  {
    title: '豆瓣8.5+国产剧 · 品质之选',
    desc: '近年来国产剧集质量飞跃，从《狂飙》到《繁花》，从古装到都市，一部部现象级好剧重新定义国产影视新高度。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20quality%20TV%20drama%20series%20visual%20with%20warm%20cinematic%20lighting%2C%20historical%20costume%20and%20modern%20drama%20blend%2C%20rich%20golden%20and%20coral%20tones%2C%20elegant%20Chinese%20aesthetic%2C%20no%20text%2C%20high%20end%20production%20photography&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '国产精选',
  },
  {
    title: '日韩美剧 · 全球热播追剧日历',
    desc: 'Netflix、Disney+、TVN热播剧一网打尽。每周更新追剧日历，韩剧美剧日剧同步追，再也不怕错过任何精彩更新。',
    img: 'https://readdy.ai/api/search-image?query=Global%20popular%20TV%20drama%20series%20collage%20Korean%20American%20Japanese%20dramas%2C%20warm%20dramatic%20lighting%2C%20international%20cinema%20aesthetic%2C%20rich%20coral%20and%20amber%20tones%2C%20no%20text%2C%20modern%20streaming%20era%20visual%20style&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '海外热播',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">
            专题策划
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑团队精心策划的影视专题合集，发现更多值得观看的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item, i) => (
            <a key={i} href="#carousel" className="group relative flex flex-col sm:flex-row bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-accent-300/50 transition-all duration-300 no-underline">
              <div className="relative sm:w-2/5 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500/90 text-background-50 text-xs font-medium rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}